import { createRouter, createWebHistory } from "vue-router";
import Main from "@/components/Main";
import Contact from "../views/Contact";

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
